import { useState, useEffect } from 'react';
import { TriangleAlert } from 'lucide-react';
interface ErrorPopupProps {
  error: string | null;
  duration?: number;
  onClose?: () => void;
}

export const ErrorPopup: React.FC<ErrorPopupProps> = ({ 
  error, 
  duration = 5000,
  onClose 
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (error) {
      setIsVisible(true);
      
      const timer = setTimeout(() => {
        setIsVisible(false);
        if (onClose) {
          onClose();
        }
      }, duration/2);

      return () => clearTimeout(timer);
    }
  }, [error, duration, onClose]);

  if (!isVisible || !error) {
    return null;
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center z-[1000000] bg-black bg-opacity-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 animate-fade-in">
        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-4">
            <TriangleAlert className="w-10 h-10 text-red-500" />
          </div>
          
          <h3 className="text-xl font-semibold text-[#34656d] mb-2">
            Error Detected
          </h3>
          
          <p className="text-gray-600 mb-4">
            {error}
          </p>
          
          <div className="w-full bg-gray-200 rounded-full h-1 overflow-hidden">
            <div 
              className="h-full bg-orange-400 animate-progress"
              style={{ animation: `progress ${duration/2}ms linear` }}
            />
          </div>
        </div>
      </div>
      
      <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        
        @keyframes progress {
          from {
            width: 100%;
          }
          to {
            width: 0%;
          }
        }
        
        .animate-fade-in {
          animation: fade-in 0.3s ease-out;
        }
        
        .animate-progress {
          animation: progress linear;
        }
      `}</style>
    </div>
  );
};
